import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import reduxMerge from "./merge";

export default function configstroe() {
  const store = createStore(reduxMerge, applyMiddleware(thunkMiddleware));
  return store;
}